import { Col } from 'components/Col';
import { CustomButton } from 'components/CustomButton';
import CloudUploadIcon from 'components/Icons/CloudUploadIcon';
import NewCustomUploader from 'components/NewCustomUploader/NewCustomUploader';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto, indexOfEtapa } from 'models/projeto';
import { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { deleteDocumento, uploadDocumento } from 'services/projeto';
import { openModal } from 'store/modules/ModalActions';
import { getFileType } from 'utils/FileUtils';
import languageValues from 'utils/LanguageUtils';
import { getUniqueKey } from 'utils/NumberUtils';
import { getProjectFilesByEtapa } from 'utils/ProjetoUtils';
import SnackbarUtils from 'utils/SnackbarUtils';

export default function FotosVideos({ etapa }: { etapa: EtapaProjeto }) {
  const {
    state: { projeto, disabledFields, etapasLoading, dirty },
    mergeAndSaveDocs,
  } = useContext(ProjetosContext);
  const d = useDispatch();
  const modalKey = useMemo(getUniqueKey, []);

  const uploaderProps = useMemo(() => {
    return {
      disabled: disabledFields,
      titleHint: languageValues.modals.uploadFotosVideos.title,
      modalKey,
      toUpload: uploadDocumento,
      getNewFileObject: (file: File) => {
        return {
          caminho: null,
          cooperativa: projeto.codigoCooperativa,
          etapa: indexOfEtapa(etapa),
          id: undefined,
          idProjeto: projeto.id,
          principal: false,
          tipo: getFileType(file.name),
          file,
        };
      },
      fileList: projeto.documentos
        ? getProjectFilesByEtapa(
            projeto.documentos,
            indexOfEtapa(etapa),
            projeto.id
          )
        : [],
      filesLimit: 5,
      onChanged: mergeAndSaveDocs,
      toRemove: deleteDocumento,
      onTypeMismatch: () => {
        SnackbarUtils.enqueueSnackbar({
          message: languageValues.toasts.error.fileType,
          options: {
            variant: 'error',
          },
        });
      },
      acceptedTypes: ['.png', '.jpg', '.jpeg', '.mp4'],
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    disabledFields,
    etapa,
    mergeAndSaveDocs,
    modalKey,
    projeto.codigoCooperativa,
    projeto.documentos,
    projeto.id,
    // IMPORTANTE QUE O DIRTY ESTEJA AQUI
    dirty,
  ]);

  return (
    <Row>
      <Col>
        <CustomButton
          disabled={etapasLoading[etapa]}
          counter={
            projeto.documentos?.length
              ? getProjectFilesByEtapa(
                  projeto.documentos,
                  indexOfEtapa(etapa),
                  projeto.id
                ).length
              : 0
          }
          theme='pufvYellow'
          label={languageValues.buttons.fotosVideos}
          onClick={() => {
            d(openModal(NewCustomUploader, uploaderProps));
          }}
          leftIcon={<CloudUploadIcon />}
        />
        <Col style={{ fontSize: '12px', width: '100%' }}>
          {languageValues.inputs.fotosVideos.helperText}
        </Col>
      </Col>
    </Row>
  );
}
